import { createFileRoute } from '@tanstack/react-router'

import PagePlaygroundReferenceBuilder from '@/pages/PagePlaygroundReferenceBuilder'
export const Route = createFileRoute('/playground/reference-builder')({
  component: PagePlaygroundReferenceBuilder,
  validateSearch: (search: Record<string, unknown>): { runId?: string } => ({
    runId: typeof search.runId === 'string' ? search.runId : undefined
  })
})
